import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '../../Components/Button';
import InputManager from '../../Components/InputManager';
import { validateEmail, validateMobile } from '../../helpers/helper';
import Alert from '../../Components/Alert';

import { addCampusAmbassador } from '../../actions/ambassador';

import './style.css';

const STREAM = ['CSE', 'IT', 'ME', 'EE', 'ECE', 'CE', 'OTHER'];

class RegistrationForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phoneNumber: '',
      college: '',
      stream: '',
      semester: '',
      resetForm: false,
      isLoading: false,
      alertMessage: '',
      alertType: 'success',
      alertActive: false
    };
    this.formRef = React.createRef();
  }

  onChange = (id, val) => {
    this.setState({ [id]: val });
  };

  validateName = val => val.trim().length < 3;

  validateEmail = val => !validateEmail(val.trim());

  validatePhone = val => !validateMobile(val.trim());

  validateText = val => val.trim().length <= 0;

  toggleLoading = (status = false) => {
    this.setState({ isLoading: status });
  };

  onSubmit = async e => {
    e.preventDefault();
    this.toggleLoading(true);
    this.removeAlert();

    const data = {
      name: this.state.name,
      phone: this.state.phoneNumber,
      email: this.state.email,
      college: this.state.college,
      stream: this.state.stream,
      semester: this.state.semester,
      voucher: this.generateRandomString()
    };

    this.props.addCampusAmbassador(data, this.onFetchCompleted);
  };

  generateRandomString = () => {
    let str = '';
    for (let i = 0; i < 10; i++) {
      str = str + Math.floor(Math.random() * 10);
    }
    return str;
  };

  onFetchCompleted = (success = false) => {
    this.toggleLoading(false);

    if (success) {
      this.clearForm();
      this.showSuccessAlert();
    } else {
      this.showFailedAlert();
    }
  };

  clearForm = () => {
    this.setState({
      name: '',
      email: '',
      phoneNumber: '',
      college: '',
      stream: '',
      semester: '',
      resetForm: true
    });
    setTimeout(() => {
      this.setState({ resetForm: false });
    }, 1000);
  };

  showAlert = () => {
    this.setState({
      alertActive: true
    });
  };

  removeAlert = () => {
    this.setState({
      alertActive: false
    });
  };

  showSuccessAlert = () => {
    this.showAlert();
    this.setState({
      alertMessage:
        'Thank You for registering for live classes. We will contact you soon.',
      alertType: 'success'
    });
  };

  showFailedAlert = () => {
    this.showAlert();
    this.setState({
      alertMessage: 'Something went wrong',
      alertType: 'failed'
    });
  };

  render() {
    const { toggleForm } = this.props;
    const { alertMessage, alertType, isLoading, alertActive } = this.state;
    return (
      <section className="live-classes-form-conatiner">
        <button onClick={toggleForm} className="live-classes-form-icon-box">
          <i className="fas fa-times"></i>
        </button>

        <p className="live-classes-form-title">Live Classes</p>
        <span className="live-classes-form-description">
          Register for our live classes.
        </span>

        <form
          className="live-classes-form"
          ref={this.formRef}
          onSubmit={this.onSubmit}>
          <InputManager
            primary
            id="name"
            placeholder="Name"
            value={this.state.name}
            onChange={this.onChange}
            validate={this.validateName}
            required={true}
            emptyText="Name is required"
            invalidText="Name must be atleast 3 characters"
            reset={this.state.resetForm}
          />

          <InputManager
            primary
            id="email"
            placeholder="Email"
            value={this.state.email}
            onChange={this.onChange}
            validate={this.validateEmail}
            required={true}
            emptyText="Email is required"
            invalidText="Invalid email address"
            reset={this.state.resetForm}
          />

          <InputManager
            primary
            id="phoneNumber"
            placeholder="Phone Number"
            value={this.state.phoneNumber}
            onChange={this.onChange}
            validate={this.validatePhone}
            required={true}
            emptyText="Phone number is required"
            invalidText="Invalid phone number"
            reset={this.state.resetForm}
          />

          <div className="live-classes-form-row">
            <div className="live-classes-form-row-left">
              <InputManager
                primary
                id="stream"
                placeholder="Choose Stream"
                type="select"
                options={STREAM}
                value={this.state.stream}
                onChange={this.onChange}
                validate={this.validateText}
                required={true}
                emptyText="Stream is required"
                //invalidText='Invalid phone number'
                reset={this.state.resetForm}
              />
            </div>

            <div className="live-classes-form-row-right">
              <InputManager
                primary
                id="semester"
                placeholder="Choose Semester"
                type="select"
                options={['1', '2', '3', '4', '5', '6', '7', '8', '8+']}
                value={this.state.semester}
                onChange={this.onChange}
                validate={this.validateText}
                required={true}
                emptyText="Semester is required"
                //invalidText='Invalid phone number'
                reset={this.state.resetForm}
              />
            </div>
          </div>

          <InputManager
            primary
            id="college"
            placeholder="College"
            value={this.state.college}
            onChange={this.onChange}
            validate={this.validateText}
            required={true}
            emptyText="College name is required"
            invalidText="must be atleast 3 characters"
            reset={this.state.resetForm}
          />

          <Button loading={isLoading} type="submit" secondary text="ENROLL" />
        </form>

        <Alert visible={alertActive} type={alertType} title={alertMessage} />
      </section>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addCampusAmbassador
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(RegistrationForm);



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/RegistrationForm.js